@if (component) {
@for(item of component.items; track item) {
@if((item.components?.length || 0) > 0 || client.isCms) {
<div [class]="{'m-t-5 m-t-4-s' : !$first}"
     (click)="open($index)"
     class="flex flex-middle flex-justify-between cursor-pointer p-a b-a _title"
     [toggleClass]="'!b-col-5 b-col-4 !bg-col-w bg-col-5'"
     [toggleClassBy]="[groupId,$index]">
    <div class="flex flex-middle">
        <i [class]="item.icon"></i>
        <p class="h3 m-l-2"
           *iCms="'title' of item"></p>
    </div>
    <i [toggleClass]="'!icon-plus icon-minus'"
       [toggleClassBy]="[groupId,$index]"
       class="icon-medium"
       style="font-size: 1.3rem;">
    </i>
</div>
@if (item.components) {
<div [toggleClassBy]="[groupId,$index]"
     [toggleClass]="'!ng-hide'"
     class="bg-col-w p-t-8 p-b-8 p-r p-l">
    <icms-outlet [components]="item.components"></icms-outlet>
</div>
}
}
}
}